import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function update(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/my_data/year/update`, params, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/my_data/year/update <br>`;
        throw new Error(errorInfo);
      }
      return res;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function add(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/my_data/year/add`, params, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/my_data/year/add <br>`;
        throw new Error(errorInfo);
      }
      return res;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function destroy(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/my_data/year/delete`, params, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/my_data/year/delete <br>`;
        throw new Error(errorInfo);
      }
      return res;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

export default {
  update,
  add,
  destroy,
};
